import React from 'react';
import Providers from "./Providers";
import {Routes} from "./Routes";

export const App = () => {

    return (
        <Providers>
            <Routes/>
        </Providers>
    );
};
